import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Container from 'react-bootstrap/Container';
import Head from 'next/head';
import Footer from '@/components/common/widgets/Footer';
import HeroSection from '@/components/homepage/HeroSection';
import Layout from '@/components/common/layouts/Layout';
import ForBigsSection from './howitworkspage/ForBigsSection';
import ForMinisSection from './howitworkspage/ForMinisSection';
import BigImageSection from './howitworkspage/BigImageSection';
import FAQSection from './howitworkspage/FAQSection';
import HIWActionSection from './howitworkspage/HIWActionSection';

function HowItWorks() {
  return (
    <Layout>
      <Head>
        <title>Big & Mini: How it works</title>
        <meta name="description" content="How exactly does our process work? This is everything you need to know." />

      </Head>
      <div id="about">

        <ParallaxProvider>
          <HeroSection
            image="/images/Mockups/Laptop/login-mockup.jpg"
            topSpace={(
              <div>
                <br />
              </div>
                         )}
            title="How It Works"
            description={"This. Is. It. What you've been looking for."}
            otherContent={(
              <div>
                <AnchorLink className="hero-button" href="#BigSection">For Individuals</AnchorLink>

                <AnchorLink className="hero-button" href="#FAQ">FAQ Section</AnchorLink>
              </div>
                          )}
          />
        </ParallaxProvider>
        <ForBigsSection />
        {/* <ForMinisSection /> */}
        <BigImageSection />
        <FAQSection />
        <HIWActionSection />
        <Footer />
      </div>
    </Layout>
  );
}

export default HowItWorks;
